import React, { useEffect, useState } from 'react';
import { getPhaseById, getPhasesByGrant } from '../../../../api/v2/PhasesApi';
import { GrantDto } from '../../../../dtos/GrantDto';
import { PhaseDto } from '../../../../dtos/PhaseDto';
import { StepDto } from '../../../../dtos/StepDto';
import { Modules } from '../../../../dtos/Modules';
import { useAppContext } from '../../../shared/AppContext';
import { TaskListProvider } from '../../../shared/tasklist/context/TaskListContext';
import Tasks from '../../../shared/tasklist/tasks/Tasks';

interface IPriorApprovalProps {
    grantData: GrantDto;
    deepLinkHash: string | null;
}
export default function PriorApprovalMain({ grantData, deepLinkHash }: IPriorApprovalProps) {
    const app = useAppContext();
    const [selectedStep, setSelectedStep] = useState<StepDto | null>(null);
    const [selectedPhase, setSelectedPhase] = useState<PhaseDto | null>(null);

    const [phaseInfo, setPhaseInfo] = useState<{ getData: () => Promise<PhaseDto | null> }[]>([]);

    useEffect(() => {
        const load = async () => {
            // Get all phases for this module in one call (filtered by valid keys on backend)
            const results = await getPhasesByGrant(grantData.id, Modules.AP);
            if (results?.error) {
                app.errorToast(results.error.message);
                return;
            }

            const phases = results?.data ?? [];

            // Create getData functions that can re-fetch fresh data by phase ID
            const items = phases.map((phase) => ({
                getData: async (): Promise<PhaseDto | null> => {
                    const result = await getPhaseById(phase.id);
                    return result?.data ?? null;
                },
            }));

            setPhaseInfo(items);
        };

        load();
    }, [app, grantData.id]);

    return (
        <TaskListProvider setSelectedStep={setSelectedStep} setSelectedPhase={setSelectedPhase}>
            <Tasks grantData={grantData} selectedStep={selectedStep} selectedPhase={selectedPhase} phasesInfo={phaseInfo} deepLinkHash={deepLinkHash} />
        </TaskListProvider>
    );
}